//@ts-nocheck
/**
 * AUTO_GENERATED Do not change this file directly, use config.ts file instead
 *
 * @version 6
 */

import { AxiosRequestConfig } from "axios";
import {
  UseQueryOptions,
  useQuery,
  useMutation,
  UseMutationOptions,
  QueryClient,
  QueryKey,
} from "@tanstack/react-query";
import { RequestError, SwaggerResponse } from "./config";

import type {
  AddNewAccessDto,
  AddNewChannelDto,
  AddNewConversationDto,
  AddNewGroupDto,
  AddNewRoleDto,
  AddNewUserDto,
  AddUserCategoryDto,
  CheckCaptchaDto,
  CheckRegistryCodeDto,
  DeleteAdminDeleteAccessQueryParams,
  DeleteAdminDeleteChannelQueryParams,
  DeleteAdminDeleteUserQueryParams,
  DeleteChatDeleteFileQueryParams,
  DeleteConversationsDto,
  DeleteMessageDto,
  DeleteUserDeleteAvatarQueryParams,
  EditMessageDto,
  ForgetPasswordDto,
  ForwardMessageDto,
  GetAdminFindUsersNewQueryParams,
  GetAdminGetAllChannelsListQueryParams,
  GetAdminGetAllGroupsListQueryParams,
  GetAdminGetUserProfileByAdminQueryParams,
  GetAdminUsersListQueryParams,
  GetAuthorityAccessListQueryParams,
  GetAuthorityFindCategoryQueryParams,
  GetAuthorityFindRolesQueryParams,
  GetAuthorityGetAccessByIdQueryParams,
  GetAuthorityGetRoleByIdQueryParams,
  GetChatConversationMessagesQueryParams,
  GetChatDownloadQueryParams,
  GetChatFindConversationsQueryParams,
  GetChatGetAllMessagesQueryParams,
  GetChatGoToMessageQueryParams,
  GetChatSearchMessageInConversationQueryParams,
  GetUserFindUserQueryParams,
  LeaveChannelGroupDto,
  LoginPasswordDto,
  LoginUserDto,
  LoginUserNameDto,
  NewPasswordDto,
  PinMessageDto,
  RegisterFcmDto,
  SendMessageDto,
  UpdateAccessDto,
  UpdateChannelAdnGroupDto,
  UpdateGroupDto,
  UpdateRoleDto,
  UpdateUserCategoryDto,
  UpdateUserPasswordDto,
  UpdateUserProfileByAdminDto,
  UpdateUserProfileDto,
  UpdateUserStatusDto,
} from "./types";
import {
  deleteAdminDeleteAccess,
  deleteAdminDeleteChannel,
  deleteAdminDeleteUser,
  deleteChatDeleteConversation,
  deleteChatDeleteFile,
  deleteChatDeleteMessage,
  deleteUserDeleteAvatar,
  getAdminDashboard,
  getAdminExportUsers,
  getAdminFindUsersNew,
  getAdminGetAllChannelsList,
  getAdminGetAllGroupsList,
  getAdminGetUserProfileByAdmin,
  getAdminUsersList,
  getAuthorityAccessList,
  getAuthorityFindCategory,
  getAuthorityFindPermissions,
  getAuthorityFindRoles,
  getAuthorityGetAccessById,
  getAuthorityGetRoleById,
  getChatConversationMessages,
  getChatDownload,
  getChatFindConversations,
  getChatGetAllMessages,
  getChatGoToMessage,
  getChatSavedMessage,
  getChatSearchMessageInConversation,
  getLoginAccessToken,
  getLoginCaptcha,
  getUserFindUser,
  getUserGetUserAvatar,
  getUserGetUserProfile,
  patchAdminUpdateUserProfileByAdmin,
  patchAuthorityUpdateCategory,
  patchUserUpdateAvatar,
  patchUserUpdateUserPassword,
  patchUserUpdateUserStatus,
  postAdminAddNewChannel,
  postAdminAddNewUser,
  postAdminExportConversationConversationId,
  postAuthorityAddCategory,
  postAuthorityAddNewAccess,
  postAuthorityAddNewRole,
  postChatAddNewConversation,
  postChatAddNewGroup,
  postChatEditMessage,
  postChatForwardMessage,
  postChatPinMessage,
  postChatSendMessage,
  postChatUploadFile,
  postLogin,
  postLoginCheckCaptcha,
  postLoginCheckCode,
  postLoginCheckPassword,
  postLoginCheckUserName,
  postLoginForgetPassword,
  postLoginLogout,
  postLoginNewPassword,
  postUserRegisterFcm,
  putAdminUpdateChannelAndGroup,
  putAuthorityUpdateAccess,
  putAuthorityUpdateRole,
  putChatLeaveChannelGroup,
  putChatUpdateGroup,
  putUserUpdateUserProfile,
} from "./services";

export type SwaggerTypescriptMutationDefaultParams<TExtra> = {
  _extraVariables?: TExtra;
  configOverride?: AxiosRequestConfig;
};
type SwaggerTypescriptUseQueryOptions<TData> = Omit<
  UseQueryOptions<SwaggerResponse<TData>, RequestError | Error>,
  "queryKey"
>;

type SwaggerTypescriptUseMutationOptions<TData, TRequest, TExtra> =
  UseMutationOptions<
    SwaggerResponse<TData>,
    RequestError | Error,
    TRequest & SwaggerTypescriptMutationDefaultParams<TExtra>
  >;

type SwaggerTypescriptUseMutationOptionsVoid<TData, TExtra> =
  UseMutationOptions<
    SwaggerResponse<TData>,
    RequestError | Error,
    SwaggerTypescriptMutationDefaultParams<TExtra> | void
  >;

export const useDeleteAdminDeleteAccess = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { queryParams: DeleteAdminDeleteAccessQueryParams },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { queryParams, configOverride } = _o || {};

      return deleteAdminDeleteAccess(queryParams, configOverride);
    },
    ...options,
  });
};

export const useDeleteAdminDeleteChannel = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { queryParams: DeleteAdminDeleteChannelQueryParams },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { queryParams, configOverride } = _o || {};

      return deleteAdminDeleteChannel(queryParams, configOverride);
    },
    ...options,
  });
};

export const useDeleteAdminDeleteUser = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { queryParams: DeleteAdminDeleteUserQueryParams },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { queryParams, configOverride } = _o || {};

      return deleteAdminDeleteUser(queryParams, configOverride);
    },
    ...options,
  });
};

export const useDeleteChatDeleteConversation = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: DeleteConversationsDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return deleteChatDeleteConversation(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useDeleteChatDeleteFile = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { queryParams: DeleteChatDeleteFileQueryParams },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { queryParams, configOverride } = _o || {};

      return deleteChatDeleteFile(queryParams, configOverride);
    },
    ...options,
  });
};

export const useDeleteChatDeleteMessage = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: DeleteMessageDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return deleteChatDeleteMessage(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useDeleteUserDeleteAvatar = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { queryParams: DeleteUserDeleteAvatarQueryParams },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { queryParams, configOverride } = _o || {};

      return deleteUserDeleteAvatar(queryParams, configOverride);
    },
    ...options,
  });
};

export const useGetAdminDashboard = (
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminDashboard.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAdminDashboard.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [getAdminDashboard.key] as QueryKey,
    fun: () => getAdminDashboard(configOverride),
  };
};
useGetAdminDashboard.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminDashboard.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAdminExportUsers = (
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminExportUsers.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAdminExportUsers.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [getAdminExportUsers.key] as QueryKey,
    fun: () => getAdminExportUsers(configOverride),
  };
};
useGetAdminExportUsers.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminExportUsers.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

export const useGetAdminFindUsersNew = (
  queryParams: GetAdminFindUsersNewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminFindUsersNew.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAdminFindUsersNew.info = (
  queryParams: GetAdminFindUsersNewQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAdminFindUsersNew.key, queryParams] as QueryKey,
    fun: () =>
      getAdminFindUsersNew(
        queryParams,

        configOverride,
      ),
  };
};
useGetAdminFindUsersNew.prefetch = (
  client: QueryClient,
  queryParams: GetAdminFindUsersNewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminFindUsersNew.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAdminGetAllChannelsList = (
  queryParams: GetAdminGetAllChannelsListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminGetAllChannelsList.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAdminGetAllChannelsList.info = (
  queryParams: GetAdminGetAllChannelsListQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAdminGetAllChannelsList.key, queryParams] as QueryKey,
    fun: () =>
      getAdminGetAllChannelsList(
        queryParams,

        configOverride,
      ),
  };
};
useGetAdminGetAllChannelsList.prefetch = (
  client: QueryClient,
  queryParams: GetAdminGetAllChannelsListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminGetAllChannelsList.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAdminGetAllGroupsList = (
  queryParams: GetAdminGetAllGroupsListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminGetAllGroupsList.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAdminGetAllGroupsList.info = (
  queryParams: GetAdminGetAllGroupsListQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAdminGetAllGroupsList.key, queryParams] as QueryKey,
    fun: () =>
      getAdminGetAllGroupsList(
        queryParams,

        configOverride,
      ),
  };
};
useGetAdminGetAllGroupsList.prefetch = (
  client: QueryClient,
  queryParams: GetAdminGetAllGroupsListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminGetAllGroupsList.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAdminGetUserProfileByAdmin = (
  queryParams?: GetAdminGetUserProfileByAdminQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminGetUserProfileByAdmin.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAdminGetUserProfileByAdmin.info = (
  queryParams?: GetAdminGetUserProfileByAdminQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAdminGetUserProfileByAdmin.key, queryParams] as QueryKey,
    fun: () =>
      getAdminGetUserProfileByAdmin(
        queryParams,

        configOverride,
      ),
  };
};
useGetAdminGetUserProfileByAdmin.prefetch = (
  client: QueryClient,
  queryParams?: GetAdminGetUserProfileByAdminQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminGetUserProfileByAdmin.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * list of all users.
 */
export const useGetAdminUsersList = (
  queryParams: GetAdminUsersListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminUsersList.info(queryParams, configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAdminUsersList.info = (
  queryParams: GetAdminUsersListQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAdminUsersList.key, queryParams] as QueryKey,
    fun: () =>
      getAdminUsersList(
        queryParams,

        configOverride,
      ),
  };
};
useGetAdminUsersList.prefetch = (
  client: QueryClient,
  queryParams: GetAdminUsersListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAdminUsersList.info(queryParams, configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAuthorityAccessList = (
  queryParams: GetAuthorityAccessListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityAccessList.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAuthorityAccessList.info = (
  queryParams: GetAuthorityAccessListQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAuthorityAccessList.key, queryParams] as QueryKey,
    fun: () =>
      getAuthorityAccessList(
        queryParams,

        configOverride,
      ),
  };
};
useGetAuthorityAccessList.prefetch = (
  client: QueryClient,
  queryParams: GetAuthorityAccessListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityAccessList.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAuthorityFindCategory = (
  queryParams: GetAuthorityFindCategoryQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityFindCategory.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAuthorityFindCategory.info = (
  queryParams: GetAuthorityFindCategoryQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAuthorityFindCategory.key, queryParams] as QueryKey,
    fun: () =>
      getAuthorityFindCategory(
        queryParams,

        configOverride,
      ),
  };
};
useGetAuthorityFindCategory.prefetch = (
  client: QueryClient,
  queryParams: GetAuthorityFindCategoryQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityFindCategory.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAuthorityFindPermissions = (
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityFindPermissions.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAuthorityFindPermissions.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [getAuthorityFindPermissions.key] as QueryKey,
    fun: () => getAuthorityFindPermissions(configOverride),
  };
};
useGetAuthorityFindPermissions.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityFindPermissions.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAuthorityFindRoles = (
  queryParams: GetAuthorityFindRolesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityFindRoles.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAuthorityFindRoles.info = (
  queryParams: GetAuthorityFindRolesQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAuthorityFindRoles.key, queryParams] as QueryKey,
    fun: () =>
      getAuthorityFindRoles(
        queryParams,

        configOverride,
      ),
  };
};
useGetAuthorityFindRoles.prefetch = (
  client: QueryClient,
  queryParams: GetAuthorityFindRolesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityFindRoles.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAuthorityGetAccessById = (
  queryParams: GetAuthorityGetAccessByIdQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityGetAccessById.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAuthorityGetAccessById.info = (
  queryParams: GetAuthorityGetAccessByIdQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAuthorityGetAccessById.key, queryParams] as QueryKey,
    fun: () =>
      getAuthorityGetAccessById(
        queryParams,

        configOverride,
      ),
  };
};
useGetAuthorityGetAccessById.prefetch = (
  client: QueryClient,
  queryParams: GetAuthorityGetAccessByIdQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityGetAccessById.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetAuthorityGetRoleById = (
  queryParams: GetAuthorityGetRoleByIdQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityGetRoleById.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetAuthorityGetRoleById.info = (
  queryParams: GetAuthorityGetRoleByIdQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getAuthorityGetRoleById.key, queryParams] as QueryKey,
    fun: () =>
      getAuthorityGetRoleById(
        queryParams,

        configOverride,
      ),
  };
};
useGetAuthorityGetRoleById.prefetch = (
  client: QueryClient,
  queryParams: GetAuthorityGetRoleByIdQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetAuthorityGetRoleById.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetChatConversationMessages = (
  queryParams: GetChatConversationMessagesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatConversationMessages.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetChatConversationMessages.info = (
  queryParams: GetChatConversationMessagesQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getChatConversationMessages.key, queryParams] as QueryKey,
    fun: () =>
      getChatConversationMessages(
        queryParams,

        configOverride,
      ),
  };
};
useGetChatConversationMessages.prefetch = (
  client: QueryClient,
  queryParams: GetChatConversationMessagesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatConversationMessages.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetChatDownload = (
  queryParams: GetChatDownloadQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatDownload.info(queryParams, configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetChatDownload.info = (
  queryParams: GetChatDownloadQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getChatDownload.key, queryParams] as QueryKey,
    fun: () =>
      getChatDownload(
        queryParams,

        configOverride,
      ),
  };
};
useGetChatDownload.prefetch = (
  client: QueryClient,
  queryParams: GetChatDownloadQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatDownload.info(queryParams, configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetChatFindConversations = (
  queryParams: GetChatFindConversationsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatFindConversations.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetChatFindConversations.info = (
  queryParams: GetChatFindConversationsQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getChatFindConversations.key, queryParams] as QueryKey,
    fun: () =>
      getChatFindConversations(
        queryParams,

        configOverride,
      ),
  };
};
useGetChatFindConversations.prefetch = (
  client: QueryClient,
  queryParams: GetChatFindConversationsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatFindConversations.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetChatGetAllMessages = (
  queryParams: GetChatGetAllMessagesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatGetAllMessages.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetChatGetAllMessages.info = (
  queryParams: GetChatGetAllMessagesQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getChatGetAllMessages.key, queryParams] as QueryKey,
    fun: () =>
      getChatGetAllMessages(
        queryParams,

        configOverride,
      ),
  };
};
useGetChatGetAllMessages.prefetch = (
  client: QueryClient,
  queryParams: GetChatGetAllMessagesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatGetAllMessages.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetChatGoToMessage = (
  queryParams: GetChatGoToMessageQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatGoToMessage.info(queryParams, configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetChatGoToMessage.info = (
  queryParams: GetChatGoToMessageQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getChatGoToMessage.key, queryParams] as QueryKey,
    fun: () =>
      getChatGoToMessage(
        queryParams,

        configOverride,
      ),
  };
};
useGetChatGoToMessage.prefetch = (
  client: QueryClient,
  queryParams: GetChatGoToMessageQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatGoToMessage.info(queryParams, configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetChatSavedMessage = (
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatSavedMessage.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetChatSavedMessage.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [getChatSavedMessage.key] as QueryKey,
    fun: () => getChatSavedMessage(configOverride),
  };
};
useGetChatSavedMessage.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatSavedMessage.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetChatSearchMessageInConversation = (
  queryParams: GetChatSearchMessageInConversationQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatSearchMessageInConversation.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetChatSearchMessageInConversation.info = (
  queryParams: GetChatSearchMessageInConversationQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getChatSearchMessageInConversation.key, queryParams] as QueryKey,
    fun: () =>
      getChatSearchMessageInConversation(
        queryParams,

        configOverride,
      ),
  };
};
useGetChatSearchMessageInConversation.prefetch = (
  client: QueryClient,
  queryParams: GetChatSearchMessageInConversationQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetChatSearchMessageInConversation.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetLoginAccessToken = (
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetLoginAccessToken.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetLoginAccessToken.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [getLoginAccessToken.key] as QueryKey,
    fun: () => getLoginAccessToken(configOverride),
  };
};
useGetLoginAccessToken.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetLoginAccessToken.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetLoginCaptcha = (
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetLoginCaptcha.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetLoginCaptcha.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [getLoginCaptcha.key] as QueryKey,
    fun: () => getLoginCaptcha(configOverride),
  };
};
useGetLoginCaptcha.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetLoginCaptcha.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useGetUserFindUser = (
  queryParams: GetUserFindUserQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetUserFindUser.info(queryParams, configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetUserFindUser.info = (
  queryParams: GetUserFindUserQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [getUserFindUser.key, queryParams] as QueryKey,
    fun: () =>
      getUserFindUser(
        queryParams,

        configOverride,
      ),
  };
};
useGetUserFindUser.prefetch = (
  client: QueryClient,
  queryParams: GetUserFindUserQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetUserFindUser.info(queryParams, configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Get user avatar .
 */
export const useGetUserGetUserAvatar = (
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetUserGetUserAvatar.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetUserGetUserAvatar.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [getUserGetUserAvatar.key] as QueryKey,
    fun: () => getUserGetUserAvatar(configOverride),
  };
};
useGetUserGetUserAvatar.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetUserGetUserAvatar.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Get user profile information .
 */
export const useGetUserGetUserProfile = (
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetUserGetUserProfile.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useGetUserGetUserProfile.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [getUserGetUserProfile.key] as QueryKey,
    fun: () => getUserGetUserProfile(configOverride),
  };
};
useGetUserGetUserProfile.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useGetUserGetUserProfile.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const usePatchAdminUpdateUserProfileByAdmin = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateUserProfileByAdminDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return patchAdminUpdateUserProfileByAdmin(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePatchAuthorityUpdateCategory = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateUserCategoryDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return patchAuthorityUpdateCategory(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePatchUserUpdateAvatar = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      requestBody: {
        /**
         *
         * - Format: binary
         */
        file?: string;
      };
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return patchUserUpdateAvatar(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * change user password.
 */
export const usePatchUserUpdateUserPassword = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateUserPasswordDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return patchUserUpdateUserPassword(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * update user status (online,offline,..).
 */
export const usePatchUserUpdateUserStatus = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateUserStatusDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return patchUserUpdateUserStatus(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostAdminAddNewChannel = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: AddNewChannelDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postAdminAddNewChannel(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * create new user by admin or operator.
 */
export const usePostAdminAddNewUser = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: AddNewUserDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postAdminAddNewUser(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostAdminExportConversationConversationId = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { conversationId: string },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        conversationId,

        configOverride,
      } = _o || {};

      return postAdminExportConversationConversationId(
        conversationId,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostAuthorityAddCategory = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: AddUserCategoryDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,
        
        configOverride,
      } = _o || {};

      return postAuthorityAddCategory(
        requestBody,
          
        configOverride,
      );
    },
    ...options,
  });
};

export const usePostAuthorityAddNewAccess = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: AddNewAccessDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postAuthorityAddNewAccess(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostAuthorityAddNewRole = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: AddNewRoleDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postAuthorityAddNewRole(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostChatAddNewConversation = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: AddNewConversationDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postChatAddNewConversation(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostChatAddNewGroup = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: AddNewGroupDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postChatAddNewGroup(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostChatEditMessage = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: EditMessageDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postChatEditMessage(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostChatForwardMessage = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: ForwardMessageDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postChatForwardMessage(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostChatPinMessage = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: PinMessageDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postChatPinMessage(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostChatSendMessage = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: SendMessageDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postChatSendMessage(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostChatUploadFile = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      requestBody: {
        conversationId?: string;
        /**
         *
         * - Format: binary
         */
        file?: string;
      };
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postChatUploadFile(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostLogin = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: LoginUserDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postLogin(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostLoginCheckCaptcha = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: CheckCaptchaDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postLoginCheckCaptcha(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostLoginCheckCode = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: CheckRegistryCodeDto; headerParams?: { registry: string } },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        headerParams,
        configOverride,
      } = _o || {};

      return postLoginCheckCode(
        requestBody,

        headerParams,
        configOverride,
      );
    },
    ...options,
  });
};

export const usePostLoginCheckPassword = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: LoginPasswordDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postLoginCheckPassword(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * authToken
 */
export const usePostLoginCheckUserName = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: LoginUserNameDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postLoginCheckUserName(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostLoginForgetPassword = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: ForgetPasswordDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postLoginForgetPassword(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePostLoginLogout = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptionsVoid<any, TExtra>,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { configOverride } = _o || {};

      return postLoginLogout(configOverride);
    },
    ...options,
  });
};

export const usePostLoginNewPassword = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: NewPasswordDto; headerParams?: { newPass: string } },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        headerParams,
        configOverride,
      } = _o || {};

      return postLoginNewPassword(
        requestBody,

        headerParams,
        configOverride,
      );
    },
    ...options,
  });
};

export const usePostUserRegisterFcm = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: RegisterFcmDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return postUserRegisterFcm(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePutAdminUpdateChannelAndGroup = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateChannelAdnGroupDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return putAdminUpdateChannelAndGroup(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePutAuthorityUpdateAccess = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateAccessDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return putAuthorityUpdateAccess(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePutAuthorityUpdateRole = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateRoleDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return putAuthorityUpdateRole(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePutChatLeaveChannelGroup = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: LeaveChannelGroupDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return putChatLeaveChannelGroup(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePutChatUpdateGroup = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateGroupDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return putChatUpdateGroup(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const usePutUserUpdateUserProfile = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: UpdateUserProfileDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return putUserUpdateUserProfile(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};
